import { situationsOne } from "./situationsP1";
import { situationsTwo } from "./situationsP2";
import { situationsThree } from "./situationsP3";
import { situationsFour } from "./situationsP4";
import { situationsFive } from "./situationsP5";
import { situationsSix } from "./situationsP6";
import { situationsSeven } from "./situationsP7";
import { situationsEight } from "./situationsP8";
import { situationsNine } from "./situationsP9";
import { situationsTen } from "./situationsP10";

export const situations = {
  one: situationsOne,
  two: situationsTwo,
  three: situationsThree,
  four: situationsFour,
  five: situationsFive,
  six: situationsSix,
  seven: situationsSeven,
  eight: situationsEight,
  nine: situationsNine,
  ten: situationsTen,
};
